import { createApi } from "@reduxjs/toolkit/query/react";
import { getBaseQuery, getBaseUrl } from "../../Utils";

interface SendEmailConfirmationResponse {
  successMessage: string;
  email: string;
}

interface SendEmailConfirmationRequest {
  email: string;
}

export const sendEmailConfirmationApi = createApi({
  reducerPath: "sendEmailConfirmationApi",
  baseQuery: getBaseQuery( getBaseUrl() ),
  endpoints: (builder) => ({
    sendEmailConfirmation: builder.mutation<SendEmailConfirmationResponse, SendEmailConfirmationRequest>({
      query: ({ email }) => ({
        url: "API/v3/page/confirmregistration",
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8" },
        body: new URLSearchParams({ EmailAddress: email }).toString(),
      }),
    }),
  }),
});

export const { useSendEmailConfirmationMutation } = sendEmailConfirmationApi;
